import { HelpCircle } from "lucide-react";

/**
 * Tiny inline help hint. Renders a `?` icon that shows a native tooltip on
 * hover — no popper libraries, no positioning bugs, works on touch as well.
 *
 * Usage:
 *   <label>Statement password <HelpHint text="Used only to open protected PDFs. Access is logged." /></label>
 */
export default function HelpHint({ text, className = "" }) {
    if (!text) return null;
    return (
        <span
            title={text}
            aria-label={text}
            tabIndex={0}
            className={`inline-flex items-center align-middle text-stone-400 hover:text-stone-700 cursor-help ml-1.5 ${className}`}
            data-testid="help-hint"
        >
            <HelpCircle size={12} strokeWidth={2} />
        </span>
    );
}
